import styleService from '@nykaa/deals-utils/styles';
import styled from '@emotion/styled';
const { getPaddingStyles, setVisibility, } = styleService.utils;
export const Wrapper = styled.div `
  text-align: ${({ align }) => align};
  background-color:${({ color }) => color};
  ${({ padding }) => getPaddingStyles(padding)};

  @media only screen  and (min-width : 768px) {
    margin-left: 48px;
    margin-right: 48px;
  }

  @media only screen  and (min-width : 1600px) {
    margin-left: auto;
    margin-right: auto;
    max-width: 1600px;
  }

  .list-wrap {
    display: flex;
    flex-wrap: wrap;
    margin: 0px -${({ interItemMargin }) => interItemMargin}px 0px -${({ interItemMargin }) => interItemMargin}px;

  }

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;
export const ListWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  margin-left: ${({ isDesktop, interItemMargin }) => (isDesktop ? `-${interItemMargin}px` : 'auto')};
  margin-right: ${({ isDesktop, interItemMargin }) => (isDesktop ? `-${interItemMargin}px` : 'auto')};
  @media ${(props) => props.theme.mq.md} { 
    align-items: flex-start;
    justify-content: center;
  }
  padding-top: ${({ padding }) => padding.top.web};

`;
export const ViewAllCTA = styled.button `
  padding: 5px 10px;
  margin-top: -32px;
  margin-right: 10px;
  background: transparent;
  border: none;
  font-size: 14px;
  letter-spacing: 1.1px;
  color: red;
  float: right;
  color: #fc2779;
  cursor: pointer;  
`;
export const ColumnWrapper = styled.div `
  box-sizing: border-box;
  width: ${({ width }) => width}%;
  vertical-align: top;
  padding: 0px ${({ interItemMargin }) => interItemMargin}px 0px ${({ interItemMargin }) => interItemMargin}px;
  position: relative;
`;
export const SubTitle = styled.h3 `
  letter-spacing: 0.3px;
  color: rgba(3, 2, 26, 0.8);
  display: block;
  font-weight: 600;
  margin: ${({ isDesktop }) => (isDesktop ? '5px auto 5px' : '5px 10px 10px 10px')};
`;
export const DesktopBgWrapper = styled.div `
${({ isDesktop, color }) => (isDesktop && `
    background:  ${color};
  `)};
  ${({ setEmptyWidget }) => setVisibility(!setEmptyWidget)};    
  `;
